module.exports = __webpack_public_path__ + "static/manage-leaves-b6480d0872bf1ba2a5e8e129385aced7.png";